export const reduxActions = {
  FETCH_PC9_FAIL: "syncfonia/fetch_pc9_fail",
  FETCH_PC9_RESET: "syncfonia/fetch_pc9_reset",
  FETCH_PC9_STARTED: "syncfonia/fetch_pc9_started",
  FETCH_PC9_SUCCESS: "syncfonia/fetch_pc9_success",
};

